import { motion } from "framer-motion";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { analytics } from "@/lib/analytics";
import { useCookieBannerVisible } from "@/hooks/useCookieBannerVisible";
import { cn } from "@/lib/utils";

export function WhatsAppButton() {
  const bannerVisible = useCookieBannerVisible();
  return (
    <aside aria-label="Quick contact">
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <motion.a
            href="https://wa.me/447457403174"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => analytics.whatsappClick()}
            className={cn(
              "fixed bottom-24 left-4 md:bottom-6 md:left-6 z-50 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-shadow hover:shadow-xl",
              bannerVisible && "hidden md:flex"
            )}
            style={{ background: "#25D366", marginBottom: "env(safe-area-inset-bottom)" }}
            
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1 }}
            aria-label="Chat on WhatsApp"
          >
            <svg viewBox="0 0 32 32" className="h-7 w-7" fill="white">
              <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.918 15.918 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.302 22.602c-.39 1.1-2.274 2.104-3.134 2.168-.86.064-1.664.388-5.608-1.168-4.738-1.87-7.724-6.726-7.956-7.038-.232-.312-1.894-2.518-1.894-4.804 0-2.286 1.2-3.41 1.626-3.876.426-.466.928-.582 1.236-.582.308 0 .616.002.886.016.284.014.666-.108.942.718.312.93 1.062 3.178 1.156 3.41.094.232.156.502.032.812-.124.312-.186.504-.372.776-.186.272-.39.608-.558.816-.186.232-.38.484-.164.948.218.466.966 1.594 2.074 2.582 1.426 1.27 2.628 1.664 3 1.85.372.186.59.156.808-.094.218-.25.934-1.088 1.184-1.462.25-.374.498-.312.84-.186.342.124 2.172 1.024 2.544 1.21.372.186.62.28.712.434.094.156.094.9-.296 2-.002 0 0 0 0 0z" />
            </svg>
          </motion.a>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>Chat on WhatsApp</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
    </aside>
  );
}
